export default "__VITE_ASSET__5046cd27__"